import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'; 

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject (PLATFORM_ID) private platformId: any,) { }
  setLocalStorage(key:string, value:any){
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }
  getLocalStorage(key:string){
    return isPlatformBrowser(this.platformId) ? JSON.parse(localStorage.getItem(key)) : {};
  }

  setSessionStorage(key:string, value:any){
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }
  getSessionStorage(key:string){
    return isPlatformBrowser(this.platformId) ? JSON.parse(sessionStorage.getItem(key)) : {}; 
  }

}
